enum PackageBuildStatus {
  Requested = "Requested",
  Processing = "Processing",
  Completed = "Completed",
  Failed = "Failed"
}

export default PackageBuildStatus;
